<template>
  <el-dialog v-bind='$attrs' v-on='$listeners' @open='onOpen' id='my-element' :destroy-on-close='true' @close='onClose'>
    <template slot='title'>
      <div style='height: 0'>
        <el-link class='pptTitle'>{{ formData.title }}</el-link>
        <svg-icon style='cursor: pointer' @click='changeFull'
                  :icon-class="fullscreen ? 'offScreen' : 'fullscreen'"></svg-icon>
        <b v-if='formData.updated_at' style='color: darkred'>（最后更新时间：{{ formData.updated_at }}）</b>
      </div>
    </template>
    <div :class="{ 'animate__animated': true, 'animate__fadeIn': showData }" class='preview-box'>
      <div>
        <transition name='el-fade-in-linear' v-if='formData.state > 0'>
          <el-image v-show='showStateImg' class='stateImg' :src='stateImg[`state_${formData.state}`]'></el-image>
        </transition>
        <el-row :gutter='24' class='base-info'>
          <el-col :span='18'>
            <div class='title'>
              <span>{{ formData.company_name }}</span>
            </div>
            <el-row>
              <el-col :span='4'>
                商品名称及规格
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.title }}({{ formData.spec_name }})</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                店铺评分
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.company_score || '/' }} 分</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                坑位费
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.ad_space_fee || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                线上/线下佣金
              </el-col>
              <el-col :span='20'>
                <span class="highlight-text">{{ formData.online_cmn + '%' || '/' }} / {{
                  formData.offline_cmn + '%' ||
                    '/'
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                日常价
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.price || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                直播价
              </el-col>
              <el-col :span='20'>
                <span class="highlight-text">{{ formData.lb_price || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                赠品
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.gift || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                是否全网统一机制
              </el-col>
              <el-col :span='20'>
                <span class="highlight-text">{{ formData._unify || '/' }}</span> &nbsp;
                <span class="highlight-text" v-if='formData.unify === 2'>{{ formData.special_remark || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                是否有签独家
              </el-col>
              <el-col :span='20'>
                <span class="highlight-text">{{ formData._exclusive || '/' }}</span> &nbsp;
                <span class="highlight-text" v-if='formData.exclusive === 1'>{{ formData.other_activity || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                是否可签保价1月
              </el-col>
              <el-col :span='20'>
                <span class="highlight-text">{{ formData._support_value || '/' }}</span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span='4'>
                历史销量
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.sales_volume || '/' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span='4'>
                备注
              </el-col>
              <el-col :span='20'>
                <span>{{ formData.remark || '/' }}</span>
              </el-col>
            </el-row>
            <el-row class='light-spot-box'>
              <div class='light-spot-title' @dblclick='editData("light")'>亮点卖点（简洁）
              </div>
              <div class='light-spot-content' v-html='formData.light_spot' @dblclick='editData("light")'>
              </div>
            </el-row>
          </el-col>
          <el-col :span='6'>
            <div class='cover-box' @dblclick="editImgBtn">
              <div class='cover-title'>
                商品图片
                <i v-if="formData.ingredient_propose_parse&&formData.ingredient_propose_parse.length!=0"
                   class="el-icon-document ingredient-icon" @click="openIngredientDialog"></i>
              </div>
              <div class='cover-view'>
                <el-image fit='cover' class='cover-image' :src='formData.cover_url'>
                  <div slot='error' class='image-slot'>
                    <div class='image-slot'>
                      <!--<i class="el-icon-picture-outline"></i>-->
                      o(╥﹏╥)o
                      <br />
                      <span>暂无图片</span>
                    </div>
                  </div>
                </el-image>
              </div>
            </div>
            <div class="introBox">
              <div class='intro' @dblclick.prevent='editData("intro")'>
                {{ formData.intro }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog width='70%' :wrapperClosable='false' @close='closeEdit' :modal='false' :destroy-on-close='true'
               :visible.sync='introVisible' append-to-body>
      <template slot='title'>
        <span class='pptTitle' style='font-size: 18px'>
          修改{{ this.editType === 'intro' ? '品牌背书' : '产品亮点' }}</span>
        <el-button style='float: right;margin-right: 50px' @click='saveEdit' type='primary'>保存
        </el-button>
      </template>
      <ApeEditor v-if="this.editType !== 'intro' && introVisible" :editorHeight='500' :inline='true'
                 :init-html='editContent' :toolbar="'undo redo paste | bold italic underline strikethrough | fontselect fontsizeselect |  forecolor backcolor | ' +
                   'ltr rtl | alignleft aligncenter alignright alignjustify | bullist numlist' +
                   ' | outdent indent blockquote | removeformat anchor hr |' +
                   ' code preview fullscreen'" @handleTinymceInput='handleTinymceInput'></ApeEditor>
      <el-input v-else type='textarea' v-model='editContent' :rows='30'></el-input>
    </el-dialog>
    <el-dialog :destroy-on-close="true" :visible.sync="editImgDialog" append-to-body title="商品图片替换" width="20%">
      <ApeUploader :limit='1' :upload-file-list='uploadFileList' uploadTip='请上传图片，最多上传1份。大小限制2M文件'
                   @handleUploadRemove='handleUploadRemove' @handleUploadSuccess='handleUploadSuccess'></ApeUploader>
      <br />
      <div style="text-align: center;">
        <el-button type="primary" @click="saveImg">提交</el-button>
        <el-button @click="cancelBtn">取消</el-button>
      </div>
    </el-dialog>

    <!-- 成分表弹框 -->
    <el-dialog :visible.sync="ingredientVisible" title="成分表" width="80%" append-to-body :destroy-on-close="true">
      <div class="ingredient-content">
        <!-- AI分析结果 -->
        <div v-if="formData.ingredient_model_nm" class="ai-analysis">
          该数据由 {{ formData.ingredient_model_nm }} 生成
        </div>

        <el-table v-if="formData.ingredient_propose_parse && formData.ingredient_propose_parse.table"
                  :data="formData.ingredient_propose_parse.table.td" border stripe class="w-full" height="400">
          <el-table-column v-for="(header, index) in getTableHeaders()" :key="index" :prop="header" :label="header"
                           :min-width="getColumnWidth(header)">
            <template slot="header">
              <span style="font-weight: bold;">{{ header }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="no-data">
          <p>暂无成分表数据</p>
        </div>

        <!-- 注意信息 -->
        <div v-if="formData.ingredient_propose_parse && formData.ingredient_propose_parse.memo">
          <h4 style="font-weight: bold; margin: 20px 0 10px 0; color: black;"> 注意: <span class="memo-content">{{
            formData.ingredient_propose_parse.memo
          }}</span>
          </h4>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="closeIngredientDialog" style="width: 100%;">关闭</el-button>
      </div>
    </el-dialog>
  </el-dialog>

</template>

<script>
import ApeEditor from '@/components/ApeEditor'
import state_1 from '@/assets/imgs/1.png'
import state_2 from '@/assets/imgs/2.png'
import state_3 from '@/assets/imgs/3.png'
import state_4 from '@/assets/imgs/4.png'
import ApeUploader from '@/components/ApeUploader'

export default {
  name: 'ProductPreviewPPT',
  components: {
    ApeEditor, ApeUploader
  },
  computed: {},
  data() {
    return {
      formData: {},
      dataList: [],
      fullscreen: true,
      stateImg: {
        state_1: state_1,
        state_2: state_2,
        state_3: state_3,
        state_4: state_4
      },
      showStateImg: true,
      introVisible: false,
      editContent: '',
      editValue: '',
      editType: '',
      showData: true,
      uploadFileList: [],
      editImgDialog: false,
      editImg: {},
      ingredientVisible: false
    }
  },
  props: {
    id: {
      type: [Number, String]
    },
    isType: {
      type: [Number, String]
    }
  },
  methods: {
    async getInfo() {
      if (this.isType !== 3) {
        const { info } = await this.$api.getProductInfo(this.id)
        this.formData = info
        this.uploadFileList = [{ url: info.cover_url }]
      } else {
        const { info } = await this.$api.getProductVideoInfo(this.id)
        this.formData = info
        this.uploadFileList = [{ url: info.cover_url }]
      }

    },
    closeEdit() {
      this.introVisible = false
    },
    editData(value) {
      this.introVisible = true
      this.editType = value
      if (value === 'intro') {
        this.editContent = this.formData.intro || ''

      } else {
        this.editContent = this.formData.light_spot || ''
      }
    },
    async onOpen() {
      this.fullscreen = localStorage.getItem('lbFullscreen') === 'true'
      this.fullscreen ? this.openFullscreen() : ''
      await this.getInfo()
    },
    onClose() {
      //记录关闭的时候 是全屏还是非全屏
      document.fullscreenElement !== null ? localStorage.setItem('lbFullscreen', 'true') : localStorage.setItem('lbFullscreen', 'false')
      this.closeFullscreen()
      this.$emit('close')
    },

    changeFull() {
      this.fullscreen = !this.fullscreen
      this.fullscreen ? this.openFullscreen() : this.closeFullscreen()
      localStorage.setItem('lbFullscreen', this.fullscreen)
    },
    async saveEdit() {
      if (this.editType === 'intro') {
        this.formData.intro = this.editContent || ''
        await this.editCellVal('formBelong', { intro: this.formData.intro, id: this.formData.id })
      } else {
        this.formData.light_spot = this.editContent || ''
        await this.editCellVal('formOther', { light_spot: this.formData.light_spot, id: this.formData.id })
      }

      this.introVisible = false
    }
    ,
    async editCellVal(name, data) {
      if (this.formData.id) {
        const id = await this.$api.saveProductPart(name, data)
        if (id) {
          this.$message.success('保存成功！')
          setTimeout(() => {
            this.showStateImg = true
          }, 600)
          this.$forceUpdate()
        }
      } else {
        this.$message.warning('参数错误，无法提交！！！')
      }
    }
    ,
    handleTinymceInput(val) {
      this.editContent = val
    }
    ,
    onchange(value) {
      this.editCellVal('state', value)
      this.formData.state = value
      this.showStateImg = false
    }
    ,
    close() {
      this.$emit('update:visible', false)
    }
    ,

    openFullscreen() {
      if (this.fullscreen) {
        if (document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled) {
          const element = document.getElementById('my-element')
          if (element.requestFullscreen) {
            element.requestFullscreen()
          } else if (element.mozRequestFullScreen) { // Firefox
            element.mozRequestFullScreen()
          } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
            element.webkitRequestFullscreen()
          } else if (element.msRequestFullscreen) { // Internet Explorer and Edge
            element.msRequestFullscreen()
          }
        }
      }
    }
    ,
    closeFullscreen() {
      if (document.exitFullscreen && document.fullscreenElement !== null) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // Internet Explorer and Edge
        document.msExitFullscreen()
      }
    }
    ,
    handleFullscreenChange() {
      if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
        this.fullscreen = true
      } else {
        this.fullscreen = false
      }
      localStorage.setItem('lbFullscreen', this.fullscreen)

    },
    editImgBtn() {
      this.editImgDialog = true
    },
    async saveImg() {
      const postData = {
        id: this.formData.id,
        cover: this.editImg.cover,
        cover_url: this.editImg.full_path
      }
      const id = await this.$api.saveProductPart('formBase', postData)
      if (id) {
        this.$message.success('成功')
        this.formData.cover_url = this.editImg.full_path
        this.editImgDialog = false
      }
    },
    // 图片删除回调
    handleUploadRemove() {
      this.editImg = this.formData.cover_url
    },
    handleUploadSuccess(file) {
      this.editImg = {
        full_path: file.full_path,
        cover: file.id
      }
    },
    cancelBtn() {
      this.editImg = {}
      this.editImgDialog = false
    },

    // 打开成分表弹框
    openIngredientDialog() {
      this.ingredientVisible = true
    },

    // 关闭成分表弹框
    closeIngredientDialog() {
      this.ingredientVisible = false
    },

    // 获取表格表头
    getTableHeaders() {
      if (this.formData.ingredient_propose_parse && this.formData.ingredient_propose_parse.table) {
        return this.formData.ingredient_propose_parse.table.th || []
      }
      return []
    },

    // 获取列宽
    getColumnWidth(header) {
      const widthMap = {
        '成分': '120',
        '作用': '200',
        '刺激性/致敏性': '150',
        '安全分': '100',
        '备注': '150'
      }
      return widthMap[header] || '120'
    }

  },
  mounted() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange) // Firefox
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange) // Chrome, Safari and Opera
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange) // Internet Explorer and Edge

  }
}
</script>

<style lang='scss' scoped>
.preview-box {
  color: #333;
  height: 100vh;
  overflow: hidden;
  font-family: "Microsoft YaHei", sans-serif;

  .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    background-color: #f8f9fa;
    padding: 10px 15px;
    margin-bottom: 15px;
    border-radius: 4px;
    color: #2c3e50;
  }

  .base-info {
    flex: 8;
    font-size: 14px;
    line-height: 1.5;

    .el-row {
      padding: 4px 8px;
      margin-bottom: 4px;

      .el-col:first-child {
        color: #666;
        font-weight: 600;
        font-size: 15px;
      }

      .el-col:last-child {
        color: #2c3e50;
        font-weight: 500;
      }
    }
  }

  .light-spot-title {
    font-size: 20px;
    font-weight: 700;
    padding: 10px 0;
    margin-bottom: 10px;
    color: #2c3e50;
  }

  .light-spot-box {
    width: 100%;
    height: 40vh;
    min-height: 180px;
    max-height: 50vh;
    background-color: #f8f9fa;
    padding: 0 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    margin-top: 12px;

    .light-spot-content {
      margin-top: 8px;
      overflow-y: auto;
      overflow-x: hidden;
      flex: 1;
      padding: 8px;
      word-wrap: break-word;
      white-space: pre-wrap;
      line-height: 1.5;
      font-size: 14px;

      > ::v-deep p {
        margin: 0 !important;
      }
    }
  }
}

.cover-box {
  flex: 4;
  background-color: #f8f9fa;
  margin-left: 4px;
  width: 100%;
  min-height: 320px;
  border-radius: 4px;
}

.cover-title {
  text-align: center;
  width: 100%;
  line-height: 28px;
  font-weight: 700;
  font-size: 20px;
  padding: 12px 0;
  color: #2c3e50;
}

.cover-view {
  padding: 8px 0;

  > * {
    width: 180px;
    display: block;
    margin: 0 auto;
    padding: 8px;
  }
}

.introBox {
  margin-top: 8px;
  border: 1px solid #e9ecef;
  border-radius: 4px;

  > * {
    padding: 8px
  }

  .intro {
    height: 45vh;
    min-height: 200px;
    max-height: 55vh;
    overflow-y: auto;
    overflow-x: hidden;
    cursor: pointer;
    padding: 8px;
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.5;
    font-size: 14px;
    background-color: #fff;
  }
}

.pptTitle {
  height: 18px;
  font-size: 16px;
  font-weight: 600;
}

.stateImg {
  width: 180px;
  height: 180px;
  position: absolute;
  display: block;
  right: 15%;
  z-index: 99;
  top: 10px;
}

.image-slot {
  text-align: center;
  margin: 40% auto;
  color: #6c757d;
  font-size: 14px;
}

.cover-image {
  width: 280px;
  height: 280px;
  display: block;
  margin: 0 auto;
}

.highlight-text {
  color: #e74c3c;
  font-weight: 500;
}

.ingredient-icon {
  margin-left: 10px;
  color: #e74c3c !important;
  cursor: pointer;
  font-size: 22px;
  transition: color 0.3s;
}

.ingredient-icon:hover {
  color: #66b1ff;
}

.ingredient-content {
  padding: 20px;
  min-height: 200px;
  line-height: 1.6;
}

.dialog-footer {
  text-align: center;
  padding: 10px 20px 20px;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 14px;
}

.ingredient-content .el-table {
  margin: 0;
}

.ingredient-content .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.ingredient-content .el-table .el-table__row:hover {
  background-color: #f5f7fa;
}

.memo-section {
  margin-top: 20px;
  padding: 15px;
  background-color: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 4px;
}

.memo-content {
  color: #909399;
  line-height: 1.6;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ai-analysis {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 4px;
  float: right;
}
</style>
<style>
.tox-tinymce-aux {
  z-index: 999999 !important;
}
</style>
